import { Pipe, PipeTransform } from '@angular/core';
import { Company, CompanySearchResultSortCriteria, PrimeStatus } from '@warema/shared/models';
import { filter } from 'rxjs/operators';

@Pipe({
    name: 'companySearchSort',
})
export class CompanySearchSortPipe implements PipeTransform {
    private readonly _primeStatusOrder = Object.values(PrimeStatus);

    public transform(
        companies: Array<Company>,
        sort: CompanySearchResultSortCriteria,
        isInstantOfferToggleOn = false,
    ): Array<Company> {
        if (!companies || !filter) {
            return companies;
        }

        const companiesCopy = [...companies];

        switch (sort) {
            case CompanySearchResultSortCriteria.GoogleRating:
                return this._sortByGoogleRanking(companiesCopy);
            case CompanySearchResultSortCriteria.PrimeStatus:
                return isInstantOfferToggleOn
                    ? this._sortByPrimeStatusWithOutdoorLivingPriority(companiesCopy)
                    : this._sortByPrimeStatusDefault(companiesCopy);
            default:
                return this._sortByDistance(companiesCopy);
        }
    }

    private _sortByDistance(companies: Array<Company>): Array<Company> {
        return companies.sort((a, b) => a.distanceValue - b.distanceValue);
    }

    private _sortByGoogleRanking(companies: Array<Company>): Array<Company> {
        return companies.sort((a, b) => b.ratingStars - a.ratingStars || a.distanceValue - b.distanceValue);
    }

    private _sortByPrimeStatusWithOutdoorLivingPriority(companies: Array<Company>): Array<Company> {
        return companies.sort((a, b) => {
            const noStatusId = -999;
            const indexA = this._primeStatusOrder.indexOf(a.primeStatus) || noStatusId;
            const indexB = this._primeStatusOrder.indexOf(b.primeStatus) || noStatusId;

            if (a.providesOutdoorLiving !== b.providesOutdoorLiving) {
                return a.providesOutdoorLiving ? -1 : 1;
            } else if (indexA < indexB) {
                return 1;
            } else if (indexA > indexB) {
                return -1;
            } else {
                return a.distanceValue - b.distanceValue;
            }
        });
    }

    private _sortByPrimeStatusDefault(companies: Array<Company>): Array<Company> {
        return companies.sort((a, b) => {
            const noStatusId = -999;
            const indexA = this._primeStatusOrder.indexOf(a.primeStatus) || noStatusId;
            const indexB = this._primeStatusOrder.indexOf(b.primeStatus) || noStatusId;

            if (indexA < indexB) {
                return 1;
            } else if (indexA > indexB) {
                return -1;
            } else {
                return a.distanceValue - b.distanceValue;
            }
        });
    }
}
